import { BoardView } from "src/client/human/game/board/BoardView/BoardView";

import { MainMenu } from "./MainMenu";
import { useGameScreenStore } from "./gameScreenStore";

export function CurrentScreen() {
  const gameScreen = useGameScreenStore((state) => state.screen);

  return gameScreen === "main-menu" ? <MainMenu /> : <BoardView />;
}
